import sortByDesc from "./sortByDesc.js";

export default function sort(arr) {
  return sortByDesc(a => a, arr);
}